export { default as UserList } from './UserList';
export { default as UserEdit } from './UserEdit';
export { default as UserDiscountCreate } from './UserDiscountCreate';
export { default as UserDiscountEdit } from './UserDiscountEdit';


// WEBPACK FOOTER //
// ./src/modules/User/pages/index.ts